import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function SimpleMailOutputNode({ id, data, handleConf, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();

  return (
    <BaseNode
      id={id}
      icon="mail_icon"
      nodeData={{ ...data, label: data?.label || 'Envoi Mail' }}
      color="tools"
      handleConf={handleConf}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <CompactNodeField
        label={msg({ id: 'field.mail.protocol.label' })}
        value={data?.protocol || 'smtp'}
      />
      <CompactNodeField label={msg({ id: 'field.mail.host.label' })} value={data?.hostURI || ''} />
      <CompactNodeField label={msg({ id: 'field.mail.port.label' })} value={data?.port || '465'} />
      {data?.username && (
        <CompactNodeField
          label={msg({ id: 'field.mail.username.label' })}
          value={data?.username || ''}
        />
      )}
      {data?.password && (
        <CompactNodeField label={msg({ id: 'field.mail.password.label' })} value="••••••" />
      )}

      <CompactNodeField
        label={msg({ id: 'field.mail.recipients.label' })}
        value={data?.recipients || ''}
      />
    </BaseNode>
  );
}

SimpleMailOutputNode.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    label: PropTypes.string,
    protocol: PropTypes.string,
    hostURI: PropTypes.string,
    port: PropTypes.string,
    username: PropTypes.string,
    password: PropTypes.string,
    subject: PropTypes.string,
    recipients: PropTypes.string,
    template: PropTypes.string
  }),
  handleConf: PropTypes.array.isRequired,
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
